module.exports = __webpack_public_path__ + "static/media/GaurangPatel.48a66207.png";